
// used only in 2 places
// I guess we can use regular collection

export default class ItemsCollection {

    constructor() {
        this._models = [];
        this._itemsById = {};
    }

    get length() {
        return this._models.length;
    }

    all() {
        return this._models;
    }

    add(id, item) {

        if (this.get(id)) {
            this.remove(id);
        }

        this._models.push(item);
        this._itemsById[id] = item;

    }

    get(id) {
        if (this._itemsById[id]) {
            return this._itemsById[id];
        }
        return false;
    }

    remove(id) {
        const item = this.get(id);

        if (!item) return;

        this._models.remove(item);
        delete this._itemsById[id];
    }


}
